import { handleActions } from 'redux-actions';
import { FormsState, RootState } from '../../../types';
import formsActions from './actions';

export default handleActions<FormsState, { formid: string; formInfo: any }>(
  {
    [formsActions.fetchFormSuccess.toString()]: (state, action) => ({
      ...state,
      [action.payload.formid]: action.payload.formInfo
    })
  },
  {}
);

export const getFormInfo = (formId?: string) => (state: RootState) =>
  formId ? state.app.forms[formId] : null;
